import { render, staticRenderFns } from "./CopyableCommand.vue?vue&type=template&id=a9ab3526&"
import script from "./CopyableCommand.vue?vue&type=script&lang=js&"
export * from "./CopyableCommand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports